import { createApp } from "vue";
import App from "./App.vue";
import "./style.scss";
import router from "./router.js";

console.log("App title", process.env.VUE_APP_TITLE);
const app = createApp(App);
app.use(router).mount("#app");